/*
================================================================ 
         Copyright (c) 2018-2020 Digitize Things Inc.           
                     All rights reserved.                       
================================================================ 
*/

import React, { useEffect, useState } from "react";
import classes from "../checkout.module.css";
import CustomerDetailBlock from "../review/customerDetailsBlock";
import NotesBlock from "../review/notesBlock";
// import { Button } from '@mui/material'
import { Link } from "react-router-dom";
import Breadcrumb from "../../../../component/breadcrumb";
import { InfoIcon } from "../../../../component/icons/icons";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import { Grid } from "@mui/material";
import NewCartBlock from "../review/newCartBlock";
import OfferingProductSpecCharacteristicsExistingDialog from "../../../pm/component/specification/offeringProductSpecCharacteristicsExistingDialog";
import OfferingProductSpecCharacteristicsDialog from "../../../pm/component/specification/offeringProductSpecCharacteristicsDialog";

const OrderPlaced = (props) => {
  const [bread] = useState([
    { title: props.t("ORDER_PLACED"), url: "/checkout" },
  ]);
  // const sideMenu = JSON.parse(localStorage.getItem('sideMenu'));
  const sideMenu = props.sideMenu;

  const [
    selectedProductSpecificationOffering,
    setSelectedProductSpecificationOffering,
  ] = useState({});
  const [selectedProductSpecification, setSelectedProductSpecification] =
    useState({});
  const [showProductSpecification, setShowProductSpecification] =
    useState(false);
  const [selectedCharacteristics, setSelectedCharacteristics] = useState([]);
  const [cartData, setCartData] = useState([]);

  useEffect(() => {
    setCartData(props.cartData);
  }, []);

  const openProductSpecification = (offering, product) => {
    // setSelectedProductSpecificationOffering(offering);
    // setSelectedProductSpecification(product);
    // setShowProductSpecification(true);
    const oldData = [...cartData];
    var cartItem = oldData[0].cartItem;
    var index = cartItem.findIndex((x) => x.index === offering.index);
    var selectedCartItem = cartItem[index];
    var productIndex = selectedCartItem.productOffering.includedItems.findIndex(
      (x) => x.id === product.id,
    );
    var selectedProduct =
      selectedCartItem.productOffering.includedItems[productIndex];
    if (selectedProduct.expandChar) {
      selectedProduct.expandChar = false;
    } else {
      selectedProduct.expandChar = true;
    }
    selectedCartItem.productOffering.includedItems[productIndex] =
      selectedProduct;
    cartItem[index] = selectedCartItem;
    oldData[0].cartItem = cartItem;
    setCartData(oldData);
    // props.setCart(oldData);
  };

  const handleCloseSpecificationDialog = () => {
    // setSelectedProductSpecificationOffering({});
    // setSelectedProductSpecification({});
    // setShowProductSpecification(false);
  };

  const handleCharacteristicsUpdate = (updatedCharacteristics) => {
    console.log("check updatedCharacteristics", updatedCharacteristics);
    // setLoading(true);

    // const oldData = [...cartData];
    // const cartItem = oldData[0].cartItem;
    // const index = cartItem.findIndex((x) => x.index === selectedProductSpecificationOffering.index);

    // const selectedCartItem = cartItem[index];
    // const productIndex = selectedCartItem.productOffering.includedItems.findIndex((x) => x.id === selectedProductSpecification.id);
    // const selectedProduct = selectedCartItem.productOffering.includedItems[productIndex];
    // if (selectedProduct.productSpec && selectedProduct.productSpec.category) {
    //     if (selectedProduct.productSpec.category.id === 'PSC_CUST_FACING') {
    //         selectedProduct.productCharsOverride = [];
    //         updatedCharacteristics.forEach(char => {
    //             selectedProduct.productCharsOverride.push({
    //                 name: char.name,
    //                 value: char.value,
    //                 specId: char.specId,
    //                 id: char.id,
    //             });
    //         });
    //     }
    // }
    // selectedCartItem.productOffering.includedItems[productIndex] = selectedProduct;
    // selectedCartItem.action = 'MODIFY';
    // const payload = {
    //     cartItem: []
    // };
    // if (props.providerType === 'SOLUTION_PROVIDER') {
    //     payload.tenantId = localStorage.getItem('selectedSalesChannel');
    // }
    // payload.cartItem.push(selectedCartItem);
    // console.log('check final payload', payload);
    // BusApiCall('PATCH', `${constants.busPublicServiceUrl}/shoppingCart/${cartData[0].id}`, payload).then(async res => {
    //     props.setErrorMessage(props.t('CHARACTERISTIC_UPDATED_SUCCESSFULLY'), true);
    //     var tempCartData = res.data;
    //     if (tempCartData && tempCartData.cartItem && tempCartData.cartItem.length > 0) {
    //         for (var s = 0; s < tempCartData.cartItem.length; s++) {
    //             if (tempCartData.cartItem[s].productOffering.includedItems && tempCartData.cartItem[s].productOffering.includedItems.length > 0) {
    //                 for (var p = 0; p < tempCartData.cartItem[s].productOffering.includedItems.length; p++) {
    //                     var filteredCategories = await updateCategory(tempCartData.cartItem[s].productOffering.includedItems[p].productSpec);
    //                     tempCartData.cartItem[s].productOffering.includedItems[p].productSpec = filteredCategories;
    //                     if (tempCartData.cartItem[s].productOffering.includedItems[p].productSpec && tempCartData.cartItem[s].productOffering.includedItems[p].productSpec.category && tempCartData.cartItem[s].productOffering.includedItems[p].productSpec.category.id === 'PSC_CUST_FACING') {
    //                         const filteredJson = await filterChildSpecs(tempCartData.cartItem[s].productOffering.includedItems[p].productSpec);
    //                         tempCartData.cartItem[s].productOffering.includedItems[p].productSpec = filteredJson;
    //                     } else {
    //                         tempCartData.cartItem[s].productOffering.includedItems[p].productSpec = {};
    //                     }
    //                 }
    //             }
    //         }
    //     }
    //     setCartData([tempCartData])
    //     props.setCart([tempCartData]);
    //     setLoading(false);
    // }).catch(err => {
    //     if (err.response && err.response.data && err.response.data.message) {
    //         props.setErrorMessage(err.response.data.message, false)
    //     } else {
    //         props.setErrorMessage(props.t('DEFAULT_ERROR_MESSAGE'), false)
    //     }
    //     setLoading(false);
    // });
  };

  return (
    <React.Fragment>
      <div className={"newContentWrapper checkPageContentWrapper"}>
        <div className={"breadcrumbWrapper"}>
          <div className={"breadcrumbContent"}>
            <Grid container>
              <Grid
                item
                size={{
                  xs: 12,
                }}
              >
                <Breadcrumb list={bread} />
              </Grid>
            </Grid>
          </div>
        </div>
      </div>
      <div style={{ marginTop: sideMenu ? "25px" : "75px" }}>
        <h2 className={classes.checkoutTitle}>
          {props.t("ORDER_PLACED_MESSAGE")}:&nbsp;
          <Link
            to={
              props.providerType === "SOLUTION_PROVIDER"
                ? `/order/${props.orderId}?tenantId=${props.salesTenantId}`
                : `/order/${props.orderId}`
            }
          >
            #{props.orderId}
          </Link>
        </h2>

        {/* {props.tenantId != 'ooredoo' && */}
        {props.providerType === "SALES_CHNL_PROVIDER" &&
          (props.orderStatus === "Waiting Customer Acceptance" ||
            props.orderStatus === "Waiting For Customer Acceptance") && (
            <div>
              <div className={classes.tcMainMessage}>
                {props.t("ACCEPT_T&C_INFO_MESSAGE")}
              </div>
              <div className={classes.tcInfoMessage}>
                <InfoIcon /> {props.t("CHECK_SPAN/JUNK_MESSAGE")}
              </div>
            </div>
          )}

        <CustomerDetailBlock
          stage={props.stage}
          edit={props.edit}
          customerDetails={props.customerDetails}
        />
        <br />
        <br />
        <NewCartBlock
          cartData={cartData}
          edit={{}}
          orderStatus={props.orderStatus}
          disabledDiscount={true}
          loggedInUserType={props.loggedInUserType}
          providerType={props.providerType}
          screen={"checkout"}
          openProductSpecification={(item, aItem) =>
            openProductSpecification(item, aItem)
          }
        />
        <br />
        <br />
        <NotesBlock
          stage={props.stage}
          notes={props.notes}
          edit={props.edit}
          loggedInUserType={props.loggedInUserType}
          orderPlaced={true}
          onChangeCustomerOrderNumber={props.onChangeCustomerOrderNumber}
        />
        {/* {showProductSpecification &&
                    <>
                        <OfferingProductSpecCharacteristicsExistingDialog t={props.t} open={showProductSpecification} productId={selectedProductSpecification.id} productName={selectedProductSpecification.name} onClose={handleCloseSpecificationDialog} componentProductCharacteristics={selectedProductSpecification.productSpec ? selectedProductSpecification.productSpec : {}} onCharacteristicsChange={handleCharacteristicsUpdate} changedCharacteristics={selectedCharacteristics || []} screen={'order'} />
                    </>
                } */}
      </div>
    </React.Fragment>
  );
};

// Get data from redux store
const mapStateToProps = (state) => {
  return {
    // solutionList: state.cart.solutions,
    // accessoryList: state.cart.accessories,
    componentList: state.cart.componentList,
    tenantId: state.auth.tenantId,
    loggedInUserType: state.auth.userLoginType,
    providerType: state.auth.providerType,
    sideMenu: state.auth.sideMenu,
  };
};

// Set data to redux store
const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation("translations")(OrderPlaced));

// export default OrderPlaced
